import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import { SolidButton } from "../buttons/SolidButton";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { LoginWithDiscord } from "../../store/actions/authActions/LoginWithDiscord";
import discordSvg from "../../assets/svg/discord-icon.svg";
import OauthPopup from "./OauthPopup";
import { useNavigate } from "react-router-dom";

type Props = {
  setRedirect: React.Dispatch<React.SetStateAction<boolean>>;
  persistentLogin: boolean;
  signup: boolean;
  qrTokenToValidate?: string;
  setDiscordCode?: React.Dispatch<React.SetStateAction<string | null>>;
};

export const DiscordLoginButton: React.FC<Props> = ({
  persistentLogin,
  signup,
  setRedirect,
  qrTokenToValidate,
  setDiscordCode,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const language = t("localization_testing");
  const navigate = useNavigate();
  const env = useAppSelector((state) => state.auth.env);
  const REACT_APP_DISCORD_CLIENT_ID = env?.REACT_APP_DISCORD_CLIENT_ID;
  const REACT_APP_DISCORD_REDIRECT_URI = env?.REACT_APP_DISCORD_REDIRECT_URI;
  const lastCode = useRef<string | null>(null); // Use ref to track the last code value

  const onCode = (code: any, params: any) => {
    if (lastCode.current === code) return; // Prevent subsequent calls with the same code
    lastCode.current = code;

    console.log("this is onCode", code);
    if (!!setDiscordCode) {
      return setDiscordCode(code);
    }

    return dispatch(
      LoginWithDiscord(
        language,
        code,
        persistentLogin,
        signup,
        setRedirect,
        navigate,
        qrTokenToValidate
      )
    );
  };

  const onClose = () => {};

  return (
    <div className="w-full">
      <OauthPopup
        url={`https://discord.com/api/oauth2/authorize?client_id=${REACT_APP_DISCORD_CLIENT_ID}&redirect_uri=${encodeURIComponent(
          REACT_APP_DISCORD_REDIRECT_URI ? REACT_APP_DISCORD_REDIRECT_URI : ""
        )}&response_type=code&scope=identify%20email`}
        title={"Discord auth"}
        width={521}
        height={861}
        onClose={onClose}
        onCode={onCode}
      >
        <SolidButton
          blackText
          backgroundColor="bg-blue-200"
          hoverColor="hover:bg-blue-300"
          width="w-full"
        >
          <div className="flex items-center space-x-2">
            <span>{t("form.continueWith")}</span>
            <img className="h-5" src={discordSvg} alt="discord" />
          </div>
        </SolidButton>
      </OauthPopup>
    </div>
  );
};
